import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Size picker + "Add to cart" button for product cards (see snippets/product-card-buy.liquid).
 *
 * This is loaded once from the theme's global script list (snippets/scripts.liquid),
 * NOT from an inline <script> inside the card markup. Cards can be inserted well after
 * the initial page load — product recommendations, filtered collection results, quick-add,
 * etc. all patch new HTML into the page via DOM morphing (see assets/morph.js), and browsers
 * never execute a <script> tag that arrives that way. A listener registered once here, on
 * `document`, keeps working for any `.pcb` element added to the page afterward, however it
 * got there.
 */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bumpCartIcon(delta) {
    var icon = document.querySelector('cart-icon');
    if (!icon || typeof icon.renderCartBubble !== 'function') return null;
    var next = Math.max(0, (icon.currentCartCount || 0) + delta);
    icon.renderCartBubble(next);
    return icon;
  }

  function addToCart(wrap, btn) {
    var id = wrap.getAttribute('data-variant-id');
    if (!id) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    // Bump the header cart count right away, so it changes the instant "Add to cart" is clicked.
    // This is just the small header number — it doesn't open the drawer, so it's safe to do early.
    var icon = bumpCartIcon(1);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add');
          return d;
        });
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (ajaxCart) {
        // Reconcile the header count with the server's real total (covers merged lines, etc.)
        if (icon && typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(ajaxCart.item_count);
        }

        // Only dispatch once the item is actually in the cart and we have its data in hand.
        // The cart drawer opens itself the moment this event fires (see cart-drawer.js),
        // so firing it here — instead of before the fetch — is what makes the drawer open
        // with the item already inside it, rather than opening first and catching up.
        document.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: id, quantity: 1 }],
            promise: Promise.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: { source: 'product-card-buy', itemCount: ajaxCart.item_count }
            })
          })
        );

        btn.textContent = 'Added \u2713';
      })
      .catch(function (err) {
        bumpCartIcon(-1); // undo the optimistic bump, the add failed
        btn.textContent = err.message || 'Error';
      })
      .then(function () {
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
        }, 1600);
      });
  }

  // Capture phase so the card's own click handlers (link / view transition) never fire
  document.addEventListener(
    'click',
    function (e) {
      var wrap = e.target.closest('.pcb');
      if (!wrap) return;
      e.stopPropagation();

      var size = e.target.closest('.pcb__size');
      if (size) {
        if (size.disabled) return;
        wrap.querySelectorAll('.pcb__size').forEach(function (b) {
          b.setAttribute('aria-pressed', b === size ? 'true' : 'false');
        });
        wrap.setAttribute('data-variant-id', size.getAttribute('data-variant-id'));
        return;
      }

      var atc = e.target.closest('button[data-pcb-atc]');
      if (atc && !atc.disabled) {
        e.preventDefault();
        addToCart(wrap, atc);
      }
    },
    true
  );
})();
